export default __webpack_public_path__ + "static/media/Abyssal Hammer.bb5eaf98.jpg";